import { BuildingTypeEnum, OfficeTypeEnum, TypeEnum } from "@/types/types";
import styles from "./category-selector.module.css";
import { useTranslations } from "next-intl";
import { useEffect, useRef, useState } from "react";
import { MdErrorOutline } from "react-icons/md";
import { KeyboardArrowDown } from "@mui/icons-material";

export default function BuildingTypeSelector({
  activeValue,
  buildingTypeError,
  officeTypeError,
  type,
  onClickBuildingType,
  onClickOfficeType,
}: {
  activeValue?: BuildingTypeEnum | OfficeTypeEnum | null;
  buildingTypeError?: string;
  officeTypeError?: string;
  type: TypeEnum;
  onClickBuildingType: (newValue: BuildingTypeEnum) => void;
  onClickOfficeType: (newValue: OfficeTypeEnum) => void;
}) {
  const t = useTranslations("NewListing.buildingType");
  const [isActive, setIsActive] = useState(false);
  const toggleRef = useRef<HTMLDivElement | null>(null);
  const buildingTypes = Object.values(BuildingTypeEnum);
  const officeTypes = Object.values(OfficeTypeEnum);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        toggleRef.current &&
        !toggleRef.current.contains(event.target as Node)
      ) {
        setIsActive(false);
      }
    };
    if (isActive) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isActive]);

  return (
    <div className={styles.inputItem}>
      <h3
        className={`${styles.fieldTitle} ${buildingTypeError && styles.error}`}
      >
        {type === TypeEnum.APARTMENT
          ? t("apartmentTitle")
          : type === TypeEnum.OFFICE && t("officeTitle")}
      </h3>
      {buildingTypeError && (
        <p className={styles.errorText}>
          {type === TypeEnum.APARTMENT
            ? t(buildingTypeError)
            : type === TypeEnum.OFFICE && t(officeTypeError)}
          <span>
            <MdErrorOutline />
          </span>
        </p>
      )}
      <div className={styles.selectorWrapper} ref={toggleRef}>
        <button
          className={`${styles.pickerWrapper} ${
            buildingTypeError && styles.error
          }`}
          onClick={() => {
            setIsActive(!isActive);
          }}
        >
          <span className={styles.selected}>
            {activeValue ? `${t(activeValue)}` : t("pick")}
          </span>
          <KeyboardArrowDown />
        </button>
        {isActive && (
          <div className={styles.selection}>
            {type === TypeEnum.APARTMENT
              ? buildingTypes.map((option, index) => {
                  return (
                    <button
                      className={styles.selectionWrapper}
                      key={option}
                      onClick={(e) => {
                        e.preventDefault();
                        onClickBuildingType(option);
                        setIsActive(false);
                      }}
                    >
                      <span>{t(option)}</span>
                      <div className={styles.separator}></div>
                    </button>
                  );
                })
              : officeTypes.map((option, index) => {
                  return (
                    <button
                      className={styles.selectionWrapper}
                      key={option}
                      onClick={(e) => {
                        e.preventDefault();
                        onClickOfficeType(option);
                        setIsActive(false);
                      }}
                    >
                      <span>{t(option)}</span>
                      <div className={styles.separator}></div>
                    </button>
                  );
                })}
          </div>
        )}
      </div>
    </div>
  );
}
